import axios from 'axios';
//maven url
export let BaseUrl = "/service.svc";
//const axios = require("axios");
export const isEmpty = (obj) => {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
}
// For Post Api Calls And Put
const HttpCall = async (url, method, params, body) => {
  const completeUrl = BaseUrl + url;
  try {
    // Prepare the headers
    const headers = {
      Accept: "application/json",
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem("token")}`, // Assuming you are using a Bearer token
    };

    // Make the HTTP request
    const response = await axios({
      method: method,
      url: completeUrl,
      data: body,
      params: {
        ...params,
      },
      headers: headers,
    });


    // Check for successful response
    if (response && response.status === 200) {
      return response.data; // Returning only the data for convenience
    }

    // Return the response even if not 200 status
    return response;
  } catch (err) {
    console.error("HTTP call failed:", err);
    // Handle the error by logging or returning a meaningful response
    throw err; // Re-throwing the error to be handled by the caller
  }
};
// For Get Api Calls
const HttpGet = async (url, params) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl =
      url.startsWith('http://') || url.startsWith('https://')
        ? url
        : BaseUrl + url;
    const token = localStorage.getItem("token");
    axios({
      method: "get",
      url: completeUrl,
      params: {
        ...params,
      },
      headers: {
        Accept: "application/json",
        Token: token,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const callApiForArray = (apiUrl, dataArray) => {
  let successCount = 0;
  let errorCount = 0;

  const promises = dataArray.map((data) => {
    return HttpCall(apiUrl, "post", {}, data)
      .then((res) => {
        successCount++;
        return res;
      })
      .catch((err) => {
        errorCount++;
        // Instead of throwing the error, return it so Promise.all continues
        return err;
      });
  });

  return Promise.all(promises)
    .then((responses) => {
      // return [responses, successCount, errorCount];
      return [responses, successCount, errorCount];
    })
    .catch((err) => {
      console.error(`Error count: ${errorCount}`);
      throw err;
    });
};
const header = () => ({ 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json', 'token': localStorage.getItem("token") ||"AmxsG7zkJB"})
export const GetRequest = async (url, queryParamsArr = false) => {
  let queryParams = '';
  Object.entries(queryParamsArr).forEach((entry, index, array) => {
    const [key, value] = entry;
    if (index === array.length - 1) {
      queryParams += `${key}=${value}`
    }
    else {
      queryParams += `${key}=${value}&`
    }
  })
  try {
    const response = await fetch(url + queryParams, { headers: header() });
    return await response.json();
  }
  catch (err) {
    return err;
  }
}
export const PostRequest = async (url, postData) => {

  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(postData),
      headers: header()
    });
    return await response.json();
  }
  catch (error) {
    return error;
  }
}
export const GetRequestNoHeader = async (url, queryParamsArr = false) => {
  let queryParams = '';
  Object.entries(queryParamsArr).forEach((entry, index, array) => {
    const [key, value] = entry;
    if (index === array.length - 1) {
      queryParams += `${key}=${value}`
    }
    else {
      queryParams += `${key}=${value}&`
    }
  })
  try {
    const response = await fetch(url + queryParams);
    return await response.json();
  }
  catch (err) {
    return err;
  }
}
const memoizedGet = () => {
  const memcache = new Map()
  return async (...args) => {
    let isCache = args?.length > 2 ? args[2] : false
    if (isCache) {
      const selector = JSON.stringify(args)
      if (memcache.has(selector)) {
        const { data, timestamp, duration } = memcache.get(selector);
        if ((Date.now() - timestamp) > duration) {
          memcache.delete(selector);
        } else {
          return data;
        }
      }
      let url = args[0]
      const completeUrl = BaseUrl + url;
      let queryParams = ''
      const postData = args[1]
      if (typeof postData != 'undefined' && !isEmpty(postData)) {
        Object.entries(postData).forEach((entry) => {
          const [key, value] = entry
          queryParams += `${key}=${value}&`
        })
        url = `${url}${queryParams}`
      }
      return new Promise(async function (resolve, reject) {
        const token = localStorage.getItem("token");
        axios({
          method: "get",
          url: completeUrl,
          params: {
            ...postData,
          },
          headers: {
            Accept: "application/json",
            Token: token,
          },
        }).then((response) => {
          let cacheDuration = args.length > 3 ? args[3] : 30 * 60 * 1000
          if (response && response.status === 200) {
            memcache.set(selector, { data: response, timestamp: Date.now(), duration: cacheDuration })
            return resolve(response);
          }
          return resolve(response);
        })
          .catch((err) => {
            return reject(err);
          });
      })
    } else {
      let url = args[0]
      const postData = args[1]
      return HttpGet(url, postData)
    }
  }
}
export const GetRequestCached = memoizedGet();

const memoisedPostWithPayload = () => {
  const cache = new Map();

  return async (url, payload, { useCache = false, cacheDuration = 30 * 60 * 1000 } = {}) => {
    if (useCache) {
      const selector = `${url}::${JSON.stringify(payload)}`;

      if (cache.has(selector)) {
        const { data, timestamp, duration } = cache.get(selector);
        if (Date.now() - timestamp < duration) {
          return data;
        }
        cache.delete(selector);
      }

      try {
        const response = await PostRequest(url, payload);
        const data = await response.json();
        cache.set(selector, { data, timestamp: Date.now(), duration: cacheDuration });
        return data;
      } catch (err) {
        console.error("POST request failed:", err);
        throw err;
      }
    }
    return PostRequest(url, payload);
  };
};

export const PostRequestCached = memoisedPostWithPayload();

export default {
  HttpCall,
  HttpGet,
  callApiForArray,
  GetRequestCached,
};